import map from '../images/worldmap.webp'
import arg from '../images/argentina.svg'
import aus from '../images/australia.svg'
import bra from '../images/brasil.svg'
import can from '../images/canada.svg'
import chi from '../images/chile.svg'
import col from '../images/colombia.svg'
import fra from '../images/france.svg'
import jap from '../images/japan.svg'
import mex from '../images/mexico.svg'
import per from '../images/peru.svg'
import esp from '../images/spain.svg'
import usa from '../images/usa.svg'
import uk from '../images/uk.svg'
import ven from '../images/venezuela.svg'
import {useTranslation } from "react-i18next"

const WorldMap = () => {
    const {t} = useTranslation()
    return(
        <section id="worldmap" className='py-8'>
            <h2 className='text-center text-3xl text-orange-600 font-bold my-6'>{t('worldheader')}</h2>
            <img src={map} alt="world map with blue backgroung, all countries we have service have orange dotted pattern and every other country has white pattern" className='mx-auto w-11/12 md:w-3/4 lg:w-3/5' />
            <div className='flex w-full flex-wrap justify-evenly px-6 my-8'>
                <img src={arg} alt="argentinian flag" className='mx-2 my-2' />
                <img src={aus} alt="asutralian flag" className='mx-2 my-2' />
                <img src={bra} alt="brazilian flag" className='mx-2 my-2' />
                <img src={can} alt="canadian flag" className='mx-2 my-2' />
                <img src={chi} alt="chilean flag" className='mx-2 my-2' />
                <img src={col} alt="colombian flag" className='mx-2 my-2' />
                <img src={fra} alt="france flag" className='mx-2 my-2' />
                <img src={jap} alt="japanese flag" className='mx-2 my-2 shadow-lg' />
                <img src={mex} alt="mexican flag" className='mx-2 my-2' />
                <img src={per} alt="perubian flag" className='mx-2 my-2' />
                <img src={esp} alt="spanish flag" className='mx-2 my-2' />
                <img src={uk} alt="UK flag" className='mx-2 my-2' />
                <img src={usa} alt="usa american flag" className='mx-2 my-2' />
                <img src={ven} alt="venezuelan flag" className='mx-2 my-2' />
            </div>
        </section>
    )
}

export default WorldMap